module.exports = __webpack_public_path__ + "images/accents/accent-video-heart-rs@1x-b4f9453e4f8680b86d18349eee68a42c.webp";